export const searchFilterBarTranslations = {
    en: {
        // Status Options
        ongoing: "Ongoing",
        upcoming: "Upcoming",
        completed: "Completed",

        // Labels
        status: "Status",
        selectHealthCamp: "Select Health Camp",
        searchPlaceholder: "search ...",

        // Tooltips
        clickToSearch: "Click to Search",
        clickToResetFilters: "Click to Reset Filters",

        // Buttons
        total: "Total",
    },
    mr: {
        // Status Options
        ongoing: "चालू",
        upcoming: "आगामी",
        completed: "पूर्ण",

        // Labels
        status: "स्थिती",
        selectHealthCamp: "आरोग्य शिबिर निवडा",
        searchPlaceholder: "शोधा ...",

        // Tooltips
        clickToSearch: "शोधण्यासाठी क्लिक करा",
        clickToResetFilters: "फिल्टर रीसेट करण्यासाठी क्लिक करा",

        // Buttons
        total: "एकूण",
    }
};
